import type { BaseFlowNode, FlowNode, NodeTypes, SenderAccountType } from '@lighthouse/shared'
import { actionDefaultNodeMap, ClassNode, OtherPlatformNodeType, TriggerNodeType } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'
import { clone } from 'rambda'

// import { getNodesWithPosition } from './getNodesPosition'

export const generateInitTriggerNode = () => {
    const newNodeId = nanoid()
    return {
        id: newNodeId,
        type: ClassNode.TRIGGER,
        data: {
            name: '开始',
            nodeType: TriggerNodeType.EMPTY_TRIGGER,
            config: {}
        },
        position: {
            x: 0,
            y: 0
        }
    }
}

export const generateNode = (
    nodeType: NodeTypes,
    options?: Partial<Omit<BaseFlowNode, 'type' | 'data'>> & { senderEmailType?: SenderAccountType }
) => {
    const newNodeId = nanoid()
    const initOption: Partial<Omit<BaseFlowNode, 'type' | 'data'>> = {
        position: { x: 0, y: 0 },
        ...options
    }
    const newNode: FlowNode = clone({ ...actionDefaultNodeMap[nodeType](), id: newNodeId, ...initOption })
    if (newNode.data.nodeType === OtherPlatformNodeType.SEND_EMAIL_ACTION && options?.senderEmailType) {
        newNode.data.config.senderAccountType = options?.senderEmailType
    }
    return newNode
}

// export const addNewNodeWithEdges = (nodeType: NodeTypes, nodes: FlowNode[], edges: FlowEdge[], target: string) => {
//     const newEdgeId = nanoid()

//     const newNode = generateNode(nodeType)

//     for (const edge of edges) {
//         if (edge.target === target) {
//             edge.target = newNode.id
//         }
//     }

//     const newEdge: FlowEdge = {
//         id: newEdgeId,
//         type: ClassEdge.Common,
//         source: newNode.id,
//         target,
//     }
//     const newEdges = [...edges, newEdge] as FlowEdge[]
//     const newNodes = [...nodes, newNode] as FlowNode[]

//     return { nodes: newNodes, edges: newEdges, newNode }
// }
